import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=46d2467e&scoped=true"
import script from "./Provider.vue?vue&type=script&lang=js"
export * from "./Provider.vue?vue&type=script&lang=js"
import style0 from "./Provider.vue?vue&type=style&index=0&id=46d2467e&prod&lang=scss&scoped=true"
import style1 from "./Provider.vue?vue&type=style&index=1&id=46d2467e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d2467e",
  null
  
)

export default component.exports